import { render } from "./SidebarNavigation.vue?vue&type=template&id=d105d9ae&scoped=true"
import script from "./SidebarNavigation.vue?vue&type=script&lang=js"
export * from "./SidebarNavigation.vue?vue&type=script&lang=js"

import "./SidebarNavigation.vue?vue&type=style&index=0&id=d105d9ae&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d105d9ae"]])

export default __exports__